"use strict";

var _slicedToArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/slicedToArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _googleMaps = require("../utils/googleMaps");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HeroSearch = function HeroSearch(props) {
  var _props$options5, _props$options6, _props$options7, _props$options8, _props$options9, _props$options10, _props$options11, _props$options12, _props$options13, _props$options14, _props$options15, _props$options16;

  // States
  var _ref = (0, _react.useState)(''),
    _ref2 = _slicedToArray(_ref, 2),
    locationTerm = _ref2[0],
    setLocationTerm = _ref2[1];
  var _ref3 = (0, _react.useState)(''),
    _ref4 = _slicedToArray(_ref3, 2),
    searchTerm = _ref4[0],
    setSearchTerm = _ref4[1];
  var _ref5 = (0, _react.useState)(''),
    _ref6 = _slicedToArray(_ref5, 2),
    lat = _ref6[0],
    setLat = _ref6[1];
  var _ref7 = (0, _react.useState)(''),
    _ref8 = _slicedToArray(_ref7, 2),
    lng = _ref8[0],
    setLng = _ref8[1];
  var _ref9 = (0, _react.useState)([]),
    _ref10 = _slicedToArray(_ref9, 2),
    places = _ref10[0],
    setPlaces = _ref10[1];
  var _ref11 = (0, _react.useState)(false),
    _ref12 = _slicedToArray(_ref11, 2),
    disableLocationSearch = _ref12[0],
    setDisableLocationSearch = _ref12[1];
  var _ref13 = (0, _react.useState)(),
    _ref14 = _slicedToArray(_ref13, 2),
    searchOptions = _ref14[0],
    setSearchOptions = _ref14[1];
  var _ref15 = (0, _react.useState)(),
    _ref16 = _slicedToArray(_ref15, 2),
    placeID = _ref16[0],
    setPlaceID = _ref16[1];
  var _ref17 = (0, _react.useState)(),
    _ref18 = _slicedToArray(_ref17, 2),
    autoComplete = _ref18[0],
    setAutoComplete = _ref18[1]; // Hooks

  (0, _react.useEffect)(function () {
    (0, _googleMaps.insertGoogleMapAPIScript)("https://maps.googleapis.com/maps/api/js?key=".concat(props.apiKey, "&libraries=places"), function () {
      var res = new window.google.maps.places.AutocompleteService();
      setAutoComplete(res);
    });
    console.log('autoComplete: ', autoComplete); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.apiKeys]); // Handle functions

  var handleResultSelect = function handleResultSelect(e, data) {
    setLocationTerm(data.result.title);
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      placeId: data.result.place_id
    }, function (res, status) {
      if (status === 'OK') {
        var _res$, _res$$geometry, _res$$geometry$locati, _res$2, _res$2$geometry, _res$2$geometry$locat;
        setSearchOptions('gloc');
        setPlaceID(data.result.place_id);
        setLat((_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$geometry = _res$.geometry) === null || _res$$geometry === void 0 ? void 0 : (_res$$geometry$locati = _res$$geometry.location) === null || _res$$geometry$locati === void 0 ? void 0 : _res$$geometry$locati.lat());
        setLng((_res$2 = res[0]) === null || _res$2 === void 0 ? void 0 : (_res$2$geometry = _res$2.geometry) === null || _res$2$geometry === void 0 ? void 0 : (_res$2$geometry$locat = _res$2$geometry.location) === null || _res$2$geometry$locat === void 0 ? void 0 : _res$2$geometry$locat.lng());
      }
    });
  };
  var handleLocationChange = function handleLocationChange(e) {
    var _props$options;
    setLocationTerm(e.target.value);
    if (e.target.value.length > ((props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.minLocationChangeTermCharacters) || 3)) {
      try {
        var _props$option, _props$option2;
        autoComplete.getPlacePredictions({
          input: e.target.value,
          types: (props === null || props === void 0 ? void 0 : (_props$option = props.option) === null || _props$option === void 0 ? void 0 : _props$option.searchType) || ['(cities)'],
          componentRestrictions: {
            country: (props === null || props === void 0 ? void 0 : (_props$option2 = props.option) === null || _props$option2 === void 0 ? void 0 : _props$option2.country) || 'us'
          }
        }, function (places) {
          for (var place in places) {
            places[place].title = places[place].description;
            places[place].description = '';
          }
          setPlaces(places);
          localStorage.setItem('places', JSON.stringify(places));
        }).catch(function (e) {
          console.log('Geocode error: ', e);
        });
      } catch (e) {
        console.log('Places Error: ', e);
      }
    } else {
      setPlaces([]);
    }
    if (e.target.value.length > 0) {
      var _props$option3;
      setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "close",
        onClick: handleClearMyLocationTermClick,
        title: (props === null || props === void 0 ? void 0 : (_props$option3 = props.option) === null || _props$option3 === void 0 ? void 0 : _props$option3.clearFieldIconTitle) || 'Clear field.',
        link: true
      }));
    } else {
      var _props$options2;
      setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "map marker alternate",
        onClick: handleLocateMeClick,
        title: (props === null || props === void 0 ? void 0 : (_props$options2 = props.options) === null || _props$options2 === void 0 ? void 0 : _props$options2.mapMarkerIconTitle) || 'Use my location',
        link: true
      }));
    }
  };
  var handleClearSearchTermClick = function handleClearSearchTermClick() {
    setSearchTerm('');
    setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  };
  var handleClearMyLocationTermClick = function handleClearMyLocationTermClick() {
    var _props$options3;
    setLocationTerm('');
    setDisableLocationSearch(false);
    setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "map marker alternate",
      onClick: handleLocateMeClick,
      title: (props === null || props === void 0 ? void 0 : (_props$options3 = props.options) === null || _props$options3 === void 0 ? void 0 : _props$options3.mapMarkerIconTitle) || 'Use my location',
      link: true
    }));
    setLat('');
    setLng('');
    setSearchOptions('');
  };
  var handleLocateMeClick = function handleLocateMeClick(e) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function setCoordinates(position) {
        var _props$options4, _props$option4;
        setLat(position.coords.latitude.toString());
        setLng(position.coords.longitude.toString());
        setSearchOptions('uloc');
        setLocationTerm((props === null || props === void 0 ? void 0 : (_props$options4 = props.options) === null || _props$options4 === void 0 ? void 0 : _props$options4.myLocationPlaceholderText) || 'My Location');
        setDisableLocationSearch(true);
        setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "close",
          onClick: handleClearMyLocationTermClick,
          title: (props === null || props === void 0 ? void 0 : (_props$option4 = props.option) === null || _props$option4 === void 0 ? void 0 : _props$option4.clearFieldIconTitle) || 'Clear field',
          link: true
        }));
      }, function (e) {});
    }
  };
  var handleLatLngChange = function handleLatLngChange() {};
  var handleTermChange = function handleTermChange(e) {
    var value = e.target.value;
    setSearchTerm(value);
    if (value.length > 0) {
      var _props$option5;
      setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "close",
        onClick: handleClearSearchTermClick,
        title: (props === null || props === void 0 ? void 0 : (_props$option5 = props.option) === null || _props$option5 === void 0 ? void 0 : _props$option5.clearFieldIconTitle) || 'Clear field.',
        link: true
      }));
    } else {
      setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
    }
  }; // Icons

  var _ref19 = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "map marker alternate",
      onClick: handleLocateMeClick,
      title: (props === null || props === void 0 ? void 0 : (_props$options5 = props.options) === null || _props$options5 === void 0 ? void 0 : _props$options5.mapMarkerIconTitle) || 'Use my location',
      link: true
    })),
    _ref20 = _slicedToArray(_ref19, 2),
    locationIcon = _ref20[0],
    setLocationIcon = _ref20[1];
  var _ref21 = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)),
    _ref22 = _slicedToArray(_ref21, 2),
    searchTermIcon = _ref22[0],
    setSearchTermIcon = _ref22[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Container, {
    className: (props === null || props === void 0 ? void 0 : (_props$options6 = props.options) === null || _props$options6 === void 0 ? void 0 : _props$options6.containerClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, {
    className: (props === null || props === void 0 ? void 0 : (_props$options7 = props.options) === null || _props$options7 === void 0 ? void 0 : _props$options7.formClassNames) || '',
    action: (props === null || props === void 0 ? void 0 : (_props$options8 = props.options) === null || _props$options8 === void 0 ? void 0 : _props$options8.searchPath) || '/search/'
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Group, {
    className: (props === null || props === void 0 ? void 0 : (_props$options9 = props.options) === null || _props$options9 === void 0 ? void 0 : _props$options9.formGroupClassNames) || '',
    widths: "equal"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
    showNoResults: true,
    noResultsMessage: '',
    className: (props === null || props === void 0 ? void 0 : (_props$options10 = props.options) === null || _props$options10 === void 0 ? void 0 : _props$options10.formSearchTermClassNames) || '',
    id: "form-subcomponent-shorthand-input-first-name",
    name: "term",
    onSearchChange: handleTermChange,
    icon: searchTermIcon,
    minCharacters: 32143124123412,
    label: "",
    value: searchTerm,
    placeholder: (props === null || props === void 0 ? void 0 : (_props$options11 = props.options) === null || _props$options11 === void 0 ? void 0 : _props$options11.searchTermPlaceholder) || 'Job Title, Keywords, Req ID'
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
    results: places,
    onSearchChange: handleLocationChange,
    onResultSelect: handleResultSelect,
    className: (props === null || props === void 0 ? void 0 : (_props$options12 = props.options) === null || _props$options12 === void 0 ? void 0 : _props$options12.formLocationTermClassNames) || '',
    minCharacters: (props === null || props === void 0 ? void 0 : (_props$options13 = props.options) === null || _props$options13 === void 0 ? void 0 : _props$options13.minLocationTermCharacters) || 4,
    disabled: disableLocationSearch,
    icon: locationIcon,
    name: "loc",
    id: "form_location",
    label: "",
    value: locationTerm,
    placeholder: (props === null || props === void 0 ? void 0 : (_props$options14 = props.options) === null || _props$options14 === void 0 ? void 0 : _props$options14.locationTermPlaceholder) || 'Location'
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: 'input_lat',
    name: 'a',
    hidden: true,
    value: lat,
    onChange: handleLatLngChange
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: 'input_lng',
    name: 'b',
    hidden: true,
    value: lng,
    onChange: handleLatLngChange
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: 'input_o',
    name: 'o',
    hidden: true,
    value: searchOptions
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: 'input_pid',
    name: 'pid',
    hidden: true,
    value: placeID
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
    className: (props === null || props === void 0 ? void 0 : (_props$options15 = props.options) === null || _props$options15 === void 0 ? void 0 : _props$options15.formSubmitButtonClassNames) || '',
    type: 'submit'
  }, (props === null || props === void 0 ? void 0 : (_props$options16 = props.options) === null || _props$options16 === void 0 ? void 0 : _props$options16.submitButtonText) || 'Find Jobs')))));
};
var _default = HeroSearch;
exports.default = _default;